document.addEventListener('click', (e) => {
  const elem = e.target
  if(!elem.closest('.dropdown')){
    document.querySelectorAll('.dropdown').forEach((dropdown)=>{
      dropdown.classList.remove('is-active');
    })
  }
})